<template class="text_google">
  <v-app>
    <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="text-right">
        <v-btn
          large
          rounded
          dark
          href="javascript:window.print()"
          class="title mr-2 rounded"
          color="info"
        >
          <v-icon class="mr-1" color="white" large>mdi-printer</v-icon>พิมพ์
        </v-btn>

  
        <v-btn
          @click.stop="
            exportToExcel('exportContent', 'ตำแหน่งว่างหลังการพิจารณาย้าย')
          "
          class="mr-1" color="green"
        >
          <v-icon>mdi-file-excel</v-icon>&nbsp; Export to excel
        </v-btn>

      </v-toolbar-items>
    </v-system-bar>

    <div id="exportContent" style="mso-page-orientation: landscape; overflow-x: scroll; overflow-x: scroll;">
      <div class="page">
        <div align="center">
          <div class="head">
            รายชื่อผู้ประสงค์ขอย้าย (กรณีปกติ) ตำแหน่งผู้อำนวยการสถานศึกษา
            ประจำปี พ.ศ.{{ year_result }}
          </div>         
        </div>
        <table class="table" border="1" width="100%" align="center">
          <tr>
            <td width="3%" class="bold16" align="center">ที่</td>
            <td width="10%" class="bold16" align="center">สถานศึกษาที่ขอย้าย</td>
            <td width="5%" class="bold16" align="center">ภาค</td>
            <td width="6%" class="bold16" align="center">จังหวัด</td>
            <td width="5%" class="bold16" align="center">ลำดับที่ขอย้าย</td>
            <td width="8%" class="bold16" align="center">ชื่อ-นามสกุล</td>
            <td width="10%" class="bold16" align="center">ตำแหน่ง</td>
            <td width="6%" class="bold16" align="center">
              เลขที่ตำแหน่ง
            </td>
            <td width="10%" class="bold16" align="center">วิทยฐานะ</td>
            <td width="10%" class="bold16" align="center">สถานศึกษาสังกัดปัจจุบัน</td>
            <td width="5%" class="bold16" align="center">ภาค</td>
            <td width="6%" class="bold16" align="center">จังหวัด</td>
            <td width="3%" class="bold16" align="center">ปีเกษียณ</td>
            <td width="10%" class="bold16" align="center">
              คุณวุฒิทางการศึกษาระดับปริญญาตรี
            </td>
            <td width="10%" class="bold16" align="center">
             สาขาวิชาระดับ ปริญญาตรี
            </td>
            <td width="10%" class="bold16" align="center">
              คุณวุฒิทางการศึกษาระดับปริญญาโท (ถ้ามี)
            </td>
            <td width="10%" class="bold16" align="center">
          สาขาวิชาระดับ ปริญญาโท
            </td>
            <td width="5%" class="bold16" align="center">ดำรงตำแหน่งปัจจุบัน ในสถานศึกษาปัจจุบัน เมื่อวันที่</td>
            <td width="5%" class="bold16" align="center">จำนวนปี</td>      
            <td width="5%" class="bold16" align="center">ครบปี</td>
            <td width="5%" class="bold16" align="center">ไม่ครบปี</td>
            <td width="5%" class="bold16" align="center">ขอย้ายกรณี</td>
            <td width="5%" class="bold16" align="center">คะแนน</td>
           
          </tr>

          <tr
            v-for="(item, index) in transference_manage_locations"
            :key="item.manage_location_id_tfl"
          >
            <td class="regular16" align="center">{{ index + 1 }}</td>
            <td class="regular16 pa-1" align="left">{{ item.college_name }}</td>
            <td class="regular16" align="center">{{ item.new_college_region }}</td>
            <td class="regular16" align="center">{{ item.new_college_province }}</td>
            <td class="regular16" align="center">
              {{ item.manage_location_sequence_n }}
            </td>
            <td class="regular16" align="center">
              {{ item.fname }}
            </td>

            <td class="regular16" align="center">{{ item.manage_location_position }}</td>
            <td class="regular16" align="center">
              {{ item.id_position }}
            </td>

            <td class="regular16" align="center">
               {{ item.rang_name }}
            </td>
            <td class="regular16" align="center">
              {{ item.college_now }}
            </td>
            <td class="regular16" align="center">{{ item.college_now_region }}</td>
            <td class="regular16" align="center">{{ item.college_now_province }}</td>
            <td class="regular16" align="center">
              {{ item.retrire_year }}
            </td>

            <td class="regular16" align="center">
              {{ item.ed_1 }}
            </td>
            <td class="regular16" align="center">
              {{ item.ed_1name }}
            </td>
            <td class="regular16" align="center">
              {{ item.ed_2 }}
            </td>
            <td class="regular16" align="center">
              {{ item.ed_2name }}
            </td>           
              <td class="regular16" align="center">
              {{ item.date_app_now | moment("add", "543 years")
                  | moment("D MMMM YYYY") }}
            </td>
              <td class="regular16" align="center">
              {{ item.manage_age_app_time }}
            </td>
              
             <td class="regular16" align="center">
             <span v-if="item.age_sup > '0'">/</span>
            </td>
            <td class="regular16" align="center">
              <span v-if="item.age_sup === '0'">/</span>
            </td>
             <td class="regular16" align="center">
              <v-chip
                color="green"
                dark
                v-if="item.manage_case_move === 'normal'"
              >
                <span style="font-size: 16px;">ย้ายปกติ</span>
              </v-chip>
              <v-chip
                color="blue"
                dark
                v-else-if="item.manage_case_move === 'quality'"
              >
                <span style="font-size: 16px;">ย้ายพัฒนาฯ</span>
              </v-chip>
              <v-chip
                color="warning"
                dark
                v-else-if="item.manage_case_move === 'special'"
              >
                <span style="font-size: 16px;">ย้ายกรณีพิเศษ</span>
              </v-chip>
            </td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    ApiKey: "HRvec2021",
    transference_manage_locations: [],
    valid: true
  }),

  async mounted() {
    await this.sweetAlertLoading()
    await this.searchTimeYear();
    Swal.close();

  },

  methods: {
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    async searchTimeYear() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage_location_detail.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.time_result,
          manage_year_s: this.year_result,   
          reportmanage2: "Ok",   
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data;
      
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    },

    exportToExcel(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Excel</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msexcel"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-excel;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".xls" : "document.xls";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    }
  },
  props: {
    source: String
  },

  computed: {
    time_result() {
      let result = window.location.href;
      let split_s = result.split("/");
      return split_s[6];
    },

    year_result() {
      let result = window.location.href;
      let split_s = result.split("/");

      return split_s[7];
    },

    type_result() {
      let result = window.location.href;
      let split_s = result.split("/");
      let type_r = split_s[8];
      if (type_r == "teach") {
        type_r = "ครู";
      } else {
        type_r = "บริหาร";
      }
      return type_r;
    }
  }
};
</script>
<style>
@import url(
  https://fonts.googleapis.com/css?family=Prompt:400,300|Roboto:400,300&subset=latin,thai
);

body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

.textAlignVer {
  display: block;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  transform: rotate(-90deg);
  position: relative;
  width: 20px;
  white-space: nowrap;
  font-size: 14px;
  margin-bottom: 5;
}

u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
  line-height: 1;
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 52cm;
  min-height: 21cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 0.5cm;
  padding-right: 0.5cm;
  padding-bottom: 0.5cm;
  padding-left: 0.5cm;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
  line-height: 1;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}
.td_line {
  border-bottom: 1pt dotted black;
}
/*.subpage {
    height: 247mm;
  }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
        border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding-top: 1cm;
    padding-right: 1cm;
    padding-bottom: 1cm;
    padding-left: 1.5cm;
  }

  .head {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
      font-size: 18px;
      font-weight: bold;
    }
    .regular12 {
      font-size: 12px;
    }
    .blod12 {
      font-size: 12px;
      font-weight: bold;
    }
    .blackRegula8 {
      font-size: 8px;
    } */
  .noprint {
    display: none;
  }
}
</style>
